export default function ActionButton({
  label,
  method,
  url,
  className,
  token,
  confirm,
  formMethod = 'post',
  data = {},
  target,
}) {
  if (method === 'get') {
    // Check if this is a modal link
    if (data['turbo-frame'] === 'modal') {
      return (
        <span className='col-auto'>
          <button
            type='button'
            className={className || []}
            data-controller='modal'
            data-modal-src-value={url}
            data-action='click->modal#load'
          >
            {label}
          </button>
        </span>
      )
    }

    return (
      <span className='col-auto'>
        {/* Links without an explicit target navigate the top page. Inside a modal (a turbo-frame)
            this breaks out of the frame instead of trying to replace it — otherwise Turbo can't
            find a matching frame in the destination and shows "Content missing". */}
        <a
          className={className || []}
          href={url}
          target={target}
          data-turbo-frame={target || data['turbo-frame'] ? undefined : '_top'}
          {...data}
        >
          {label}
        </a>
      </span>
    )
  } else {
    return makeFormAction(label, method, url, { className, token, confirm, formMethod, data })
  }
}

function makeFormAction(label, method, url, { className, token, formMethod, data = {} }) {
  return (
    <form action={url} method={formMethod} className='col-auto'>
      <input type='hidden' name='_method' value={method} />
      <input type='hidden' name='authenticity_token' value={token} />
      <button type='submit' className={className || []} {...data}>
        {label}
      </button>
    </form>
  )
}
